module.exports = __webpack_public_path__ + "img/Blog-Image.8ca57236.png";